var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSmoothie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58449 6.63886C4.68895 6.51841 4.84055 6.44922 4.99999 6.44922H11C11.1594 6.44922 11.311 6.51841 11.4155 6.63886C11.52 6.75931 11.567 6.91916 11.5445 7.077L10.5445 14.077C10.5057 14.348 10.2737 14.5492 9.99999 14.5492H5.99999C5.72628 14.5492 5.49422 14.348 5.45551 14.077L4.45551 7.077C4.43296 6.91916 4.48002 6.75931 4.58449 6.63886ZM5.63414 7.54922L6.477 13.4492H9.52297L10.3658 7.54922H5.63414Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 4.54922C6.64691 4.54922 5.55001 5.64612 5.55001 6.99922H4.45001C4.45001 5.03861 6.0394 3.44922 8.00001 3.44922C9.96062 3.44922 11.55 5.03861 11.55 6.99922H10.45C10.45 5.64612 9.35311 4.54922 8.00001 4.54922Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45001 1.99922C7.45001 1.69546 7.69626 1.44922 8.00001 1.44922H11V2.54922H8.55001V3.99922H7.45001V1.99922Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSmoothie);
export default __webpack_public_path__ + "static/media/ico_smoothie.7dd847071209000878c3c0331923898b.svg";
export { ForwardRef as ReactComponent };